import React, { useEffect, useCallback, useState} from 'react';
import ExploreGuilds from "components/explore/guilds/ExploreGuilds.js";
import {setIsManagingGuilds} from 'actions/index.js';
import {connect} from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import { Badge, Label, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';

const GuildsModal = ({isManaging, setIsManagingGuilds}) => { 
    if (!isManaging) {
        return [];
    }
    console.log("MANAGING");
    return (
        <Modal dialogClassName="preset-modal guilds-modal" show={true} onHide={() => setIsManagingGuilds(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Groups</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ExploreGuilds/>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setIsManagingGuilds(false)}>
              Done
            </Button>
          </Modal.Footer>
        </Modal>
    );
}

const mapStateToProps = (state, props) => {
  return {
      isManaging: state.guilds.isManaging
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
        setIsManagingGuilds: show=> dispatch(setIsManagingGuilds(show))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GuildsModal);
